var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18.75 10L1.25 1.25 7.695 10 1.25 18.75 18.75 10z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }